import type { SectionPlanInfo, WorkoutPlanInfoId } from '@az3fr/core';
import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/lib/store';
import { sectionPlanAdapter } from '@/entities/section-plan/model/section-plan.slice';

const baseSelectors = sectionPlanAdapter.getSelectors((state: RootState) => state.sectionPlans);

const selectAllByWorkoutPlanId = createSelector(
	[baseSelectors.selectAll, (_, workoutPlanId: WorkoutPlanInfoId | null) => workoutPlanId],
	(allSectionPlans, workoutPlanId) => {
		if (!workoutPlanId) {
			return [];
		}

		// `.sort()` is handled by the adapter
		return allSectionPlans.filter(
			(section: SectionPlanInfo) => section.workoutPlanId === workoutPlanId,
		);
	},
);

const sectionPlanSliceSelectors = {
	...baseSelectors,
	selectAllByWorkoutPlanId,
};

export { sectionPlanSliceSelectors };
